export default __webpack_public_path__ + "static/media/AnimalFeaturesTail_08.1624b4cb.png";